module.exports = __webpack_public_path__ + "assets/images/680d154a92a9492a91c7c7bac3656e0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/kp-kiosk/kp-kiosk-1.jpg
// module id = 809
// module chunks = 0